import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class BoutiqueService extends BaseService {

    static url = "boutique";
    static apis = {
        getBoutiqueData: { path: this.url, method: "get" },
        createDealer: { path: this.url+'/createDealer', method: "post" },
        getAll: { path: this.url+'/getAll', method: "get" },
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("boutique");
    }

    getBoutiqueData(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: BoutiqueService.apis.getBoutiqueData.path+'/'+id,
                    method: BoutiqueService.apis.getBoutiqueData.method,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    getAll() {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: BoutiqueService.apis.getAll.path,
                    method: BoutiqueService.apis.getAll.method,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    getBoutiqueEquipment(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: '/kits/filter?brands=['+id+']&kitSource=[3]',
                    method: 'get',
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    createDealer(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: BoutiqueService.apis.createDealer.path,
                    method: BoutiqueService.apis.createDealer.method,
                    data: data,
                    showLoader: true,
                    authorization: false,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error.response);
                });
        });
    }

}

export default BoutiqueService;